import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ViewInspiration = ({ inspirationItem, onClose }) => {
    return (
        <div className="modal show d-block" tabIndex="-1" style={{ background: "rgba(0, 0, 0, 0.2)" }}>
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div
                    className="modal-content shadow border-0 rounded text-dark"
                    style={{
                        background: "#F8F6F2", // Near-White Creamy Background
                        color: "#5A4A42", // Soft Dark Brown Text
                        backdropFilter: "blur(10px)",
                        borderRadius: "15px",
                        border: "1px solid #EDE4D1", // Subtle Beige Border
                    }}
                >

                    {/* Modal Header */}
                    <div
                        className="modal-header border-0"
                        style={{
                            background: "#F2ECE1", // Soft Warm Header
                            borderRadius: "15px 15px 0 0"
                        }}
                    >
                        <h5 className="modal-title fw-bold">Inspiration Details</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    {/* Modal Body with Scrollable Content */}
                    <div className="modal-body overflow-auto" style={{ maxHeight: "70vh" }}>

                        {/* ID */}
                        <div className="p-2 rounded mb-2" style={{ background: "#F2ECE1", border: "1px solid #EDE4D1" }}>
                            <strong>ID:</strong> {inspirationItem?._id}
                        </div>

                        {/* Tittle */}
                        <div className="p-2 rounded mb-2" style={{ background: "#F2ECE1", border: "1px solid #EDE4D1" }}>
                            <strong>Tittle:</strong> {inspirationItem?.title}
                        </div>
                        {/* Height */}
                        <div className="p-2 rounded mb-2" style={{ background: "#F2ECE1", border: "1px solid #EDE4D1" }}>
                            <strong>Height:</strong> {inspirationItem?.height}
                        </div>

                        {/* Width */}
                        <div className="p-2 rounded mb-2" style={{ background: "#F2ECE1", border: "1px solid #EDE4D1" }}>
                            <strong>Width:</strong> {inspirationItem?.width}
                        </div>

                        {/* Main Image */}
                        <div className="text-center">
                            <label className="d-block fw-bold mb-1 text-dark">Image:</label>
                            <div className="overflow-hidden rounded mb-3 border" style={{ border: "1px solid #EDE4D1" }}>
                                <img
                                    src={inspirationItem?.referenceImage}
                                    alt="Tattoo"
                                    className="img-fluid rounded"
                                    style={{ transition: "transform 0.3s ease-in-out" }}
                                    onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                                    onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
                                />
                            </div>
                        </div>

                        {/* Thumbnail Image */}
                        <div className="text-center">
                            <label className="d-block fw-bold mb-1 text-dark">Thumbnail:</label>
                            <div className="overflow-hidden rounded mb-3 border" style={{ border: "1px solid #EDE4D1" }}>
                                <img
                                    src={inspirationItem?.thumb}
                                    alt="Thumbnail"
                                    className="img-fluid rounded"
                                    style={{ transition: "transform 0.3s ease-in-out" }}
                                    onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
                                    onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
                                />
                            </div>
                        </div>

                    </div>

                    {/* Modal Footer */}
                    <div
                        className="modal-footer border-0"
                        style={{
                            background: "#F2ECE1",
                            borderRadius: "0 0 15px 15px"
                        }}
                    >
                        <button className="btn btn-secondary text-dark fw-bold" onClick={onClose}>Close</button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ViewInspiration;
